import { useState, useEffect, useRef } from 'react';
import { callService } from "@Utils/ServiceUtils";
import { useHistory,  } from 'react-router';
import {  isEmpty } from '@Views/utils/StringUtils';
import { getToday } from '@Views/utils/DateUtils';


const Profile = ({ msg, userInfo, setUserInfo }: any) => {

    const history = useHistory();
    const win: any = window;

    let [termsViewActive, setTermsViewActive] = useState<boolean>(false);
    let [chooseOption, setChooseOption] = useState<boolean>(false);

    const idRef: any = useRef();
    const currentPasswordRef: any = useRef();
    const passwordRef: any = useRef();
    const passwordConfirmRef: any = useRef();
    const nameRef: any = useRef();
    const emailPreFixRef: any = useRef();
    const jobRef: any = useRef();

    const OSUUD03R02 = async () => {

        const res = await callService('OSUUD03R02');

        idRef['current']['value'] = res['usrId'];
        nameRef['current']['value'] = res['usrNm'];
        jobRef['current']['value'] = res['ocptCd'];
        emailPreFixRef['current']['value'] = res['cntctEaddr'];

        if (!isEmpty(res['ocptCd'])) {
            const ele: any = document.querySelector('#radio-12');
            ele['checked'] = true;
            setChooseOption(true);
        }
        else {
            const ele: any = document.querySelector('#radio-11');
            ele['checked'] = true;
            setChooseOption(false);
        }

    }

    const OSUUD03U03 = async () => {

        let id = idRef['current']['value'];
        let currentPassword = currentPasswordRef['current']['value'];
        let password = passwordRef['current']['value'];
        let passwordConfirm = passwordConfirmRef['current']['value'];
        let name = nameRef['current']['value'];
        let emailPrefix = emailPreFixRef['current']['value'];
        let job = jobRef['current']['value'];

        if (currentPassword || password || passwordConfirm) {

            if (isEmpty(currentPassword)) {
                alert('현재 비밀번호를 입력해주세요.');
                currentPasswordRef['current'].focus();
                return;
            }
            else if (isEmpty(password)) {
                alert('새 비밀번호를 입력해주세요.');
                passwordRef['current'].focus();
                return;
            }
            else if (isEmpty(passwordConfirm)) {
                alert('비밀번호 확인을 입력해주세요.');
                passwordConfirmRef['current'].focus();
                return;
            }
            // 패스워드 체크
            const regExpPassword = /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{9,20}$/;
            if (!regExpPassword.test(password)) {
                alert('비밀번호가 조건에 맞지않습니다.');
                passwordRef['current'].focus();
                return;
            }

            if (password !== passwordConfirm) {
                alert('비밀번호 확인이 같지않습니다.');
                passwordConfirmRef['current'].focus();
                return;
            }
        }
        // 220421 - 회원가입시 본인인증적용으로 아이디 readonly 설정
        // else if (isEmpty(name)) {
        //     alert('이름을 입력해주세요.');
        //     nameRef['current'].focus();
        //     return;
        // }
        else if (isEmpty(emailPrefix)) {
            alert('이메일을 입력해주세요.');
            emailPreFixRef['current'].focus();
            return;
        }

        const email = emailPreFixRef['current']['value'];
        //이메일체크
        const regExpEmail = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
        if (!regExpEmail.test(email)) {
            alert('이메일 형식이 아닙니다.');
            emailPreFixRef['current'].focus();
            return;
        }

        // 선택 입력 여부
        if (chooseOption) {
            if (isEmpty(job)) {
                alert('직업을 입력해주세요.');
                jobRef['current'].focus();
                return;
            }
        }

        const params = {
            usrId: id,
            oldPwd: currentPassword,
            newPwd: password,
            cnfmPwd: passwordConfirm,
            usrNm: name,
            cntctEaddr: email,
            ocptCd: chooseOption ? job : null
        }

        const res = await callService('OSUUD03U03', params);

        if (res['sucsYn'] === 'N') {
            alert("에러발생");
        } else {
            alert("수정완료");
            history.push('/');
        }

    }

    const onClickRadioAgree = (isAgree: boolean) => {
        setChooseOption(isAgree);
    }

    const deleteUsr = () => {
        win.confirm("정말로 탈퇴하시겠습니까?", async function () {
            const res = await OBMUC02U01('D');
            if (res['resltCcnt'] === 1) {
                history.push('/');
                sessionStorage.removeItem('userInfo');
                setUserInfo();
            }
        })

    }

    const OBMUC02U01 = async (iudFlag: string) => {
        var params = userInfo;
        params['iudFlag'] = iudFlag;
        params['zRegDtm'] = getToday();

        var param = {
            otsdUsrSub: [params]
        }

        return await callService('OBMUC02U01', param);
    }

    useEffect(() => {
        OSUUD03R02();
    }, []);

    return (
        <>
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="join-step">
                    <div className="join-step-head">
                        <div className="left">
                            <h2>회원정보수정</h2>
                        </div>
                    </div>
                    <div className="join-step-body">
                        <div className="equired">
                            <h3><strong>필수항목</strong></h3>
                            <fieldset>
                                <div className="input-group-div">
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box input-box-btn clearfix">
                                                <label htmlFor="text-1">아이디</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" id="text-1" ref={idRef} disabled />
                                                    <button type="button" className="btn" onClick={deleteUsr}>회원탈퇴</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label htmlFor="text-2">이름</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="text" id="text-2" ref={nameRef} disabled />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label htmlFor="pw-1">현재 비밀번호</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="password" id="pw-1" ref={currentPasswordRef} placeholder="현재 비밀번호를 입력해주세요." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label htmlFor="pw-2">새 비밀번호</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="password" id="pw-2" ref={passwordRef} placeholder="새로 사용할 비밀번호를 입력해주세요." />
                                                </div>
                                                <p className="input-guide text-important">비밀번호 9자 이상 영문대소문자, 숫자, 특수문자만 가능합니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box clearfix">
                                                <label htmlFor="pw-3">비밀번호 확인</label>
                                                <div className="input-group">
                                                    <input className="form-control" type="password" id="pw-3" ref={passwordConfirmRef} placeholder="새 비밀번호를 한번 더 입력해주세요." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box input-box-select clearfix">
                                                <label htmlFor="text-3">E-mail</label>
                                                <div className="input-group">
                                                    <input className="form-control email" type="text" id="text-3" ref={emailPreFixRef} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div className={"optional" + (!chooseOption ? " disabled" : "")}>
                            <h3><strong>선택항목</strong></h3>
                            <fieldset>
                                <div className="input-group-div"></div>
                                <div className="input-group-div">
                                    <div className="toggle-wrap toggle-hj">
                                        <div className={"btn-wrap" + (termsViewActive ? ' active' : '')}>
                                            <button type="button" className="btn btn-title" title="열기" onClick={() => { setTermsViewActive(!termsViewActive) }}>
                                                <strong>[선택] 개인정보 수집 동의</strong>
                                            </button>
                                        </div>
                                        <div className="toggle-list">
                                            <div className="message">
                                                <p><strong>1. 개인정보의 수집 및 이용목적</strong><br />
                                                    [한국은행 경제통계 홈페이지]는 다음의 목적을 위해 귀하의 개인정보를 수집하고자 하오며 수집된 개인정보는 목적 이외의 용도로는 사용되지 않습니다. 이용목적이 변경될 시에는 사전에 별도의 동의를 구할 것입니다. <br /><br />가. 회원관리 : 회원제 서비스 이용을 위한 가입의사 확인, 분쟁 조정을 위한 기록보존, 고지사항 전달 등 <br />나. 민원처리 : 한국은행 경제통계 홈페이지 업무와 관련된 게시판 질의응답, 민원을 원활하게 처리하기 위하여 개인 정보를 처리합니다. <br />다. 기타 : 본인확인, 개인식별, 부정이용 방지, 비인가 사용 방지, 홈페이지 개선의견 수집, 접속빈도 파악, 서비스 이용에 대한 통계 수집 등을 목적으로 개인정보를 처리합니다.<br /><br />
                                                    <strong>2. 수집하는 개인정보의 항목</strong><br />[한국은행 경제통계 홈페이지]는 당행이 제공하는 서비스를 이용하기 위하여 필요한 최소한의 개인정보(필수정보)를 수집처리하고 있습니다. 아울러 서비스 이용과정에서 자동으로 생성되는 정보(IP주소, 쿠키, 방문 일시, 서비스 이용기록, 불량 이용기록 등)는 홈페이지 개선과 보안대책 수립 등의 목적으로 이용됩니다. 본 홈페이지에서 수집·처리하는 개인정보 항목은 다음과 같습니다.<br /><br />가. 일반회원 가입 <br />
                                                    &nbsp; ￭ [필수] 아이디, 이름, 이메일 <br />
                                                    &nbsp; ￭ [선택] 직업<br /><br />
                                                    나. 게시판 등 글쓰기 <br />&nbsp; ￭ [필수] 이름, 이메일</p>
                                            </div>
                                            <div className="radio-group">
                                                <div className="right">
                                                    <div className="form-group form-group-radio">
                                                        <div className="input-box-group">
                                                            <div className="input-box">
                                                                <div className="input-group">
                                                                    <input type="radio" id="radio-11" name="radio-1" onChange={() => { onClickRadioAgree(false) }} />
                                                                    <label htmlFor="radio-11"><span>미동의</span></label>
                                                                </div>
                                                                <div className="input-group">
                                                                    <input type="radio" id="radio-12" name="radio-1" onChange={() => { onClickRadioAgree(true) }} />
                                                                    <label htmlFor="radio-12"><span>동의</span></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-wrap">
                                        <div className="form-group">
                                            <div className="input-box-group">
                                                <div className="input-box input-box-select clearfix">
                                                    <label htmlFor="select-1">직업</label>
                                                    <div className="input-group">
                                                        <select className="form-control" id="select-1" disabled={!chooseOption} ref={jobRef}>
                                                            <option value="">직업선택</option>
                                                            <option value="00002">학생</option>
                                                            <option value="00004">금융인</option>
                                                            <option value="00001">회사원</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div className="btn-group btn-130">
                            <button type="button" className="btn btn-popup negative" title="회원정보를 취소합니다." onClick={() => history.push('/')}>취소</button>
                            <button type="button" className="btn btn-popup positive" title="회원정보를 수정합니다." onClick={OSUUD03U03}>수정</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Profile;